
const userprofile = [{"key":"userprofile.title","string":"Twój profil w bazie kontaktów"},{"key":"userprofile.button.update_profile","string":"Uaktualnij profil"},{"key":"userprofile.no_profile","string":"Jeszcze nie dodałeś\/aś profilu do bazy kontaktów."}]

export default userprofile



// WEBPACK FOOTER //
// ./src/i18n/pl/adduserprofile/userprofile.js